module.exports = __webpack_public_path__ + "img/1547206030.2ed1b4e2.jpg";